import React from 'react'

const CheckBoxIcon = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      fontSize={'inherit'}
    >
      <circle cx="11" cy="11" r="10.5" stroke="#DADADA" />
    </svg>
  )
}

export default CheckBoxIcon
